export { default } from './Legend.container';



// WEBPACK FOOTER //
// src/components/googleMap/Legend/index.js